import { TIPO_COMISION_POR_PUBLICAR } from '../../constants/pedidoEstados.js'
import { validarRangoFechas } from '../dateValidation.js'
import { calcPrecioPedido } from './matchHelpers.js'

const obtenerFechaRegistro = (p) =>
  p.tipoRegistro === TIPO_COMISION_POR_PUBLICAR
    ? p.ordenSecundario
    : (p?.ventaItems?.[0]?.fechaPedido ?? p.fechaPedido)

export const MAPA_PEDIDOS = {
  comprador: {
    titulo: 'Comprador',
    campoExport: ({ esVentas }) => (esVentas ? 'empidComprador' : 'comprador'),
    opciones: ({ pedidos, esVentas }) => [
      ...new Map(
        pedidos.flatMap((p) =>
          (p.pedidoItems ?? []).map((item) =>
            esVentas
              ? [
                  item.empidComprador,
                  {
                    label: item.compradorRazonSocial || item.compradorNombre,
                    valor: item.empidComprador
                  }
                ]
              : [
                  p.idComprador,
                  {
                    label: item.compradorNombre || item.compradorRazonSocial,
                    valor: p.idComprador
                  }
                ]
          )
        )
      ).values()
    ],
    filterFn: (p, v, filtros) =>
      filtros?.esVentas
        ? (p.pedidoItems ?? []).some((item) => item.empidComprador === v)
        : p.idComprador === v
  },

  vendedor: {
    titulo: 'Vendedor',
    campoExport: ({ esVentas }) => (esVentas ? 'idVendedor' : 'empidVendedor'),
    opciones: ({ pedidos, esVentas }) => [
      ...new Map(
        pedidos.flatMap((p) =>
          (p.pedidoItems ?? []).map((item) => {
            const valor = esVentas ? item.idVendedor : item.empidVendedor
            return [
              valor,
              {
                label: esVentas
                  ? item.vendedorNombre || item.vendedorRazonSocial
                  : item.vendedorRazonSocial || item.vendedorNombre,
                valor
              }
            ]
          })
        )
      ).values()
    ],

    filterFn: (p, v, filtros) =>
      (p.pedidoItems ?? []).some((item) =>
        filtros?.esVentas ? item.idVendedor === v : item.empidVendedor === v
      )
  },

  compradorEmpresa: {
    esArbol: true,
    campoExport: () => 'empidComprador',
    filterFn: (p, v) =>
      (p.pedidoItems ?? []).some((item) => String(item.empidComprador) === String(v))
  },
  compradorUsuario: {
    esArbol: true,
    campoExport: () => 'comprador',
    filterFn: (p, v) => String(p.idComprador) === String(v)
  },

  vendedorEmpresa: {
    esArbol: true,
    campoExport: () => 'empidVendedor',
    filterFn: (p, v) =>
      (p.pedidoItems ?? []).some((item) => String(item.empidVendedor) === String(v))
  },
  vendedorUsuario: {
    esArbol: true,
    campoExport: () => 'idVendedor',
    filterFn: (p, v) => (p.pedidoItems ?? []).some((item) => String(item.idVendedor) === String(v))
  },

  idPedidoItemEstado: {
    titulo: 'Estado del envío',
    opciones: ({ pedidos }) => [
      ...new Map(
        pedidos.flatMap((p) =>
          (p.pedidoItems ?? []).map((item) => [
            item.idPedidoItemEstado,
            { valor: item.idPedidoItemEstado, label: item.estadoNombre }
          ])
        )
      ).values()
    ],
    filterFn: (p, v) => (p.pedidoItems ?? []).some((item) => item.idPedidoItemEstado === v)
  },

  idPagoEstado: {
    titulo: 'Estado del pago',
    opciones: ({ pedidos }) => [
      ...new Map(
        pedidos.flatMap((p) =>
          (p.pedidoItems ?? []).map((item) => [
            item.idPagoEstado,
            { valor: item.idPagoEstado, label: item.estadoPago }
          ])
        )
      ).values()
    ],
    filterFn: (p, v) => (p.pedidoItems ?? []).some((item) => item.idPagoEstado === v)
  },

  precioDesde: { tipo: 'precio', filterFn: (p, v) => calcPrecioPedido(p) >= Number(v) },
  precioHasta: { tipo: 'precio', filterFn: (p, v) => calcPrecioPedido(p) <= Number(v) },

  fechaDesde: {
    tipo: 'fecha',
    label: 'compra desde',
    filterFn: (p, v) => validarRangoFechas(v, obtenerFechaRegistro(p), 'day')
  },
  fechaHasta: {
    tipo: 'fecha',
    label: 'compra hasta',
    filterFn: (p, v) => validarRangoFechas(obtenerFechaRegistro(p), v, 'day')
  },

  esVentas: {
    filterFn: (p, v, filtros) => {
      const idUsuario = Number(filtros?.idUsuario)
      if (filtros?.esAdmin || !idUsuario) {
        return true
      }
      return v ? p.idVendedor === idUsuario : p.idComprador === idUsuario
    }
  },

  textoBusqueda: {
    placeholder: 'Buscar por título o NRO pedido...',
    filterFn: (p, v, filtros) => {
      const val = v.trim().toLowerCase()
      if (!val) return true
      const items = Array.isArray(p.pedidoItems) ? p.pedidoItems : []
      return (
        items.some((item) => (item?.titulo || '').toLowerCase().includes(val)) ||
        (filtros.esVentas
          ? items.some((item) => (item?.compradorNombre || '').toLowerCase().includes(val))
          : items.some((item) => (item?.vendedorNombre || '').toLowerCase().includes(val))) ||
        p.idPedido.toString().includes(val)
      )
    }
  }
}
